import { render, staticRenderFns } from "./router_a.vue?vue&type=template&id=2179a007&"
import script from "./router_a.vue?vue&type=script&lang=js&"
export * from "./router_a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports